import { colors } from 'quasar'
import {
  ACCOUNT_RIGHT_CREATE_AGENT,
  ACCOUNT_RIGHT_CREATE_CHECKPOINT,
  ACCOUNT_RIGHT_CREATE_CUSTOMER,
  ACCOUNT_RIGHT_CREATE_INVOICE,
  ACCOUNT_RIGHT_CREATE_MISSION,
  ACCOUNT_RIGHT_CREATE_MISSION_EVENT,
  ACCOUNT_RIGHT_CREATE_ROUND,
  ACCOUNT_RIGHT_CREATE_SITE,
  ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS,
  ACCOUNT_RIGHT_READ_SITES_PLANNING
} from '@/consts/rights'

/**
 * Clé de stockage de la donnée dans le local storage
 * @type {string}
 */
export const STORAGE_KEY = 'LWF'

export const APP_MODE_PLATFORM = 'platform'
export const APP_MODE_TERRAIN = 'terrain'

export const ROLE_AGENT = 'agent'

export const ROLE_MANAGER = 'manager'

export const ROLE_ADMIN = 'admin'

export const ROLE_CLIENT = 'customer'

export const APP_NOTIF_SERVICE_EVENT = 'serviceEvent'
export const APP_NOTIF_SERVICE_LATE = 'serviceLate'
export const APP_NOTIF_SERVICE_SOON = 'serviceSoon'
export const APP_NOTIF_PLANNING_EDITED = 'planningEdited'
export const APP_NOTIF_PLANNING_UPDATED = 'planningUpdated'
export const APP_NOTIF_GROUP_PTI = 'lwfPti'
export const APP_NOTIF_SITE_INSTRUCTIONS_UPDATED = 'siteInstructionsUpdated'
export const APP_NOTIF_SUPERVISION_AGENT_LOCATION = 'supervisionAgentLocation'

export const APP_HOLIDAY_DEFAULT_LOCALE = 'fr'

export const INDETERMINATE_STATUS = {
  label: 'Indéterminé',
  name: 'Indéterminé',
  color: 'black',
  icon: 'fas fa-question'
}
const color = colors.getBrand('primary')
export const DEFAULT_LOCATION = {
  lat: 43.836699,
  lng: 4.360054
}
export const DEFAULT_LOCATION_MARKER_ICON = {
  path: 'm 0,-42.080002 c 3.18114,0 5.76,2.57886 5.76,5.76 0,3.18114 -2.57886,5.76 -5.76,5.76 -3.18114,0 -5.76,-2.57886 -5.76,-5.76 0,-3.18114 2.57886,-5.76 5.76,-5.76 m 4.32,12.96 H 3.2976 c -2.04399,0.93987 -4.4631,0.98046 -6.5952,0 H -4.32 c -2.3859,0 -4.32,1.9341 -4.32,4.32 v 12.24 c 0,1.19295 0.96705,2.16 2.16,2.16 h 1.44 v 12.24 c 0,1.19295 0.96705,2.16 2.16,2.16 h 5.76 c 1.19295,0 2.16,-0.96705 2.16,-2.16 v -12.24 h 1.44 c 1.19295,0 2.16,-0.96705 2.16,-2.16 v -12.24 c 0,-2.3859 -1.9341,-4.32 -4.32,-4.32 z',
  // circle = 'M 2.5,0 A 2.5,2.5 0 0 1 0,2.5 2.5,2.5 0 0 1 -2.5,0 2.5,2.5 0 0 1 0,-2.5 2.5,2.5 0 0 1 2.5,0 Z'
  fillColor: color,
  fillOpacity: 1,
  strokeWeight: 2,
  strokeOpacity: 0.5,
  strokeColor: '#000'
}
export const MAP_ACCURACY_CIRCLE_OPTIONS = {
  strokeColor: color,
  strokeOpacity: 0.5,
  strokeWeight: 2,
  fillColor: color,
  fillOpacity: 0.35
}

export const DATATABLE_ROWS_PER_PAGE_OPTIONS = [5, 10, 25, 50, 100, 250]

export const WEEK_DAYS = [
  {
    value: 1,
    label: 'Lundi'
  },
  {
    value: 2,
    label: 'Mardi'
  },
  {
    value: 3,
    label: 'Mercredi'
  },
  {
    value: 4,
    label: 'Jeudi'
  },
  {
    value: 5,
    label: 'Vendredi'
  },
  {
    value: 6,
    label: 'Samedi'
  },
  {
    value: 0,
    label: 'Dimanche'
  }
]

/**
 * Les mois de l'année
 */
export const YEAR_MONTHS = [
  {
    value: 1,
    label: 'Janvier'
  },
  {
    value: 2,
    label: 'Février'
  },
  {
    value: 3,
    label: 'Mars'
  },
  {
    value: 4,
    label: 'Avril'
  },
  {
    value: 5,
    label: 'Mai'
  },
  {
    value: 6,
    label: 'Juin'
  },
  {
    value: 7,
    label: 'Juillet'
  },
  {
    value: 8,
    label: 'Août'
  },
  {
    value: 9,
    label: 'Septembre'
  },
  {
    value: 10,
    label: 'Octobre'
  },
  {
    value: 11,
    label: 'Novembre'
  },
  {
    value: 12,
    label: 'Décembre'
  }
]

export const YEAR_MONTHS_ZERO_INDEXED = YEAR_MONTHS.map((m, value) => ({
  ...m,
  value
}))

export const YEAR_TRIMESTER = [
  {
    value: 0,
    label: 'Trimestre 1'
  },
  {
    value: 3,
    label: 'Trimestre 2'
  },
  {
    value: 6,
    label: 'Trimestre 3'
  },
  {
    value: 9,
    label: 'Trimestre 4'
  }
]

export const YEAR_SEMESTER = [
  {
    value: 0,
    label: 'Semestre 1'
  },
  {
    value: 6,
    label: 'Semestre 2'
  }
]

export const WEEK_DAYS_INDEXED = _.keyBy(WEEK_DAYS, 'value')

export const TVA_LIST = [
  0,
  7.7,
  8.5,
  10,
  17,
  19,
  20,
  21
]
export const CURRENCY_EURO = {
  value: 'EUR',
  label: 'Euro',
  symbol: '€'
}
export const CURRENCY_LIST = [
  CURRENCY_EURO,
  {
    value: 'MAD',
    label: 'Dirham',
    symbol: 'د.م.'
  },
  {
    value: 'GBP',
    label: 'Livre',
    symbol: '£'
  },
  {
    value: 'USD',
    label: 'Dollar',
    symbol: '$'
  },
  {
    value: 'CHF',
    label: 'Franc Suisse',
    symbol: 'CHF'
  },
  {
    value: 'XOF',
    label: 'Franc CFA',
    symbol: 'XOF'
  },
  {
    value: 'GHS',
    label: 'Cedi',
    symbol: 'GHS'
  },
  {
    value: 'MUR',
    label: 'Roupie',
    symbol: 'MUR'
  },
  {
    value: 'RUB',
    label: 'Rouble',
    symbol: 'RUB'
  },
  {
    value: 'SAR',
    label: 'Riyal',
    symbol: 'SAR'
  },
  {
    value: 'IRR',
    label: 'Rial',
    symbol: 'IRR'
  },
  {
    value: 'TRY',
    label: 'Lira',
    symbol: 'TRY'
  },
  {
    value: 'CUP',
    label: 'Peso',
    symbol: 'CUP'
  },
  {
    value: 'DZD',
    label: 'Dinar algérien',
    symbol: 'DA'
  }
]

export const CURRENCY_INDEXED = _.keyBy(CURRENCY_LIST, 'value')

export const TIME_ZONE_LIST = [
  {
    value: 'international-date-line-west',
    label: 'UTC-12:00 - International Date Line West'
  },
  {
    value: 'midway-island-samoa',
    label: 'UTC-11:00 - Midway Island, Samoa'
  },
  {
    value: 'hawaii',
    label: 'UTC-10:00 - Hawaii'
  },
  {
    value: 'alaska',
    label: 'UTC-08:00 - Alaska'
  },
  {
    value: 'arizona',
    label: 'UTC-07:00 - Arizona'
  },
  {
    value: 'pacific-time-us-and-canada',
    label: 'UTC-07:00 - Pacific Time, US & Canada'
  },
  {
    value: 'tijuana-baja-california',
    label: 'UTC-07:00 - Tijuana, Baja California'
  },
  {
    value: 'central-america',
    label: 'UTC-06:00 - Central America'
  },
  {
    value: 'chihuahua-la-paz-mazatlan',
    label: 'UTC-06:00 - Chihuahua, La Paz, Mazatlan'
  },
  {
    value: 'mountain-time-us-and-canada',
    label: 'UTC-06:00 - Mountain Time, US & Canada'
  },
  {
    value: 'saskatchewan',
    label: 'UTC-06:00 - Saskatchewan'
  },
  {
    value: 'bogota-lima-quito-rio-branco',
    label: 'UTC-05:00 - Bogota, Lima, Quito, Rio Branco'
  },
  {
    value: 'central-time-us-and-canada',
    label: 'UTC-05:00 - Central Time, US & Canada'
  },
  {
    value: 'guadalajara-mexico-city-monterrey',
    label: 'UTC-05:00 - Guadalajara, Mexico City, Monterrey'
  },
  {
    value: 'caracas',
    label: 'UTC-04:30 - Caracas'
  },
  {
    value: 'asuncion',
    label: 'UTC-04:00 - Asuncion'
  },
  {
    value: 'cuba',
    label: 'UTC-04:00 - Cuba'
  },
  {
    value: 'cuiaba',
    label: 'UTC-04:00 - Cuiaba'
  },
  {
    value: 'eastern-time-us-and-canada',
    label: 'UTC-04:00 - Eastern Time, US & Canada'
  },
  {
    value: 'georgetown-la-paz-manaus-san-juan',
    label: 'UTC-04:00 - Georgetown, La Paz, Manaus, San Juan'
  },
  {
    value: 'indiana-east',
    label: 'UTC-04:00 - Indiana (East)'
  },
  {
    value: 'atlantic-time-canada',
    label: 'UTC-03:00 - Atlantic Time, Canada'
  },
  {
    value: 'atlantic-time-goose-bay',
    label: 'UTC-03:00 - Atlantic Time, Goose Bay'
  },
  {
    value: 'brasilia',
    label: 'UTC-03:00 - Brasilia'
  },
  {
    value: 'buenos-aires',
    label: 'UTC-03:00 - Buenos Aires'
  },
  {
    value: 'cayenne-fortalenza',
    label: 'UTC-03:00 - Cayenne, Fortalenza'
  },
  {
    value: 'montevideo',
    label: 'UTC-03:00 - Montevideo'
  },
  {
    value: 'santiago',
    label: 'UTC-03:00 - Santiago'
  },
  {
    value: 'newfoundland',
    label: 'UTC-02:30 - Newfoundland'
  },
  {
    value: 'coordinated-universal-time-02',
    label: 'UTC-02:00 - Coordinated Universal Time - 02'
  },
  {
    value: 'greenland',
    label: 'UTC-02:00 - Greenland'
  },
  {
    value: 'mid-atlantic',
    label: 'UTC-02:00 - Mid-Atlantic'
  },
  {
    value: 'cape-verde-is',
    label: 'UTC-01:00 - Cape Verde Is.'
  },
  {
    value: 'azores',
    label: 'UTC-00:00 - Azores'
  },
  {
    value: 'coordinated-universal-time',
    label: 'UTC-00:00 - Coordinated Universal Time'
  },
  {
    value: 'monrovia-reykjavik',
    label: 'UTC-00:00 - Monrovia, Reykjavik'
  },
  {
    value: 'casablanca',
    label: 'UTC+01:00 - Casablanca'
  },
  {
    value: 'dublin-lisbon-london-edinburgh',
    label: 'UTC+01:00 - Dublin, Lisbon, London, Edinburgh'
  },
  {
    value: 'west-central-africa',
    label: 'UTC+01:00 - West Central Africa'
  },
  {
    value: 'amsterdam-berlin-bern-rome-stockholm-vienna',
    label: 'UTC+02:00 - Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'
  },
  {
    value: 'belgrade-bratislava-budapest-prague-ljubljana',
    label: 'UTC+02:00 - Belgrade, Bratislava, Budapest, Prague, Ljubljana'
  },
  {
    value: 'brussels-copenhagen-madrid-paris',
    label: 'UTC+02:00 - Brussels, Copenhagen, Madrid, Paris'
  },
  {
    value: 'cairo',
    label: 'UTC+02:00 - Cairo'
  },
  {
    value: 'harare-pretoria',
    label: 'UTC+02:00 - Harare, Pretoria'
  },
  {
    value: 'sarajevo-skopje-warsaw-zagreb',
    label: 'UTC+02:00 - Sarajevo, Skopje, Warsaw, Zagreb'
  },
  {
    value: 'windhoek',
    label: 'UTC+02:00 - Windhoek'
  },
  {
    value: 'amman',
    label: 'UTC+03:00 - Amman'
  },
  {
    value: 'athens-bucharest',
    label: 'UTC+03:00 - Athens, Bucharest'
  },
  {
    value: 'baghdad',
    label: 'UTC+03:00 - Baghdad'
  },
  {
    value: 'beirut',
    label: 'UTC+03:00 - Beirut'
  },
  {
    value: 'damascus',
    label: 'UTC+03:00 - Damascus'
  },
  {
    value: 'helsinki-kyiv-riga-sofia-tallinn-vilnius',
    label: 'UTC+03:00 - Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius'
  },
  {
    value: 'istanbul',
    label: 'UTC+03:00 - Istanbul'
  },
  {
    value: 'jerusalem',
    label: 'UTC+03:00 - Jerusalem'
  },
  {
    value: 'kaliningrad-minsk',
    label: 'UTC+03:00 - Kaliningrad, Minsk'
  },
  {
    value: 'kuwait-riyadh',
    label: 'UTC+03:00 - Kuwait, Riyadh'
  },
  {
    value: 'moscow-st-petersburg-volgograd',
    label: 'UTC+03:00 - Moscow, St. Petersburg, Volgograd'
  },
  {
    value: 'nairobi',
    label: 'UTC+03:00 - Nairobi'
  },
  {
    value: 'nicosia',
    label: 'UTC+03:00 - Nicosia'
  },
  {
    value: 'abu-dhabi-muscat',
    label: 'UTC+04:00 - Abu Dhabi, Muscat'
  },
  {
    value: 'tbilisi',
    label: 'UTC+04:00 - Tbilisi'
  },
  {
    value: 'yerevan',
    label: 'UTC+04:00 - Yerevan'
  },
  {
    value: 'kabul',
    label: 'UTC+04:30 - Kabul'
  },
  {
    value: 'tehran',
    label: 'UTC+04:30 - Tehran'
  },
  {
    value: 'asia-tashkent',
    label: 'UTC+05:00 - Asia/Tashkent'
  },
  {
    value: 'baku',
    label: 'UTC+05:00 - Baku'
  },
  {
    value: 'chennai-kolkata-mumbai-new-delhi',
    label: 'UTC+05:30 - Chennai, Kolkata, Mumbai, New Delhi'
  },
  {
    value: 'kathmandu',
    label: 'UTC+05:45 - Kathmandu'
  },
  {
    value: 'astana-dhaka',
    label: 'UTC+06:00 - Astana, Dhaka'
  },
  {
    value: 'ekaterinburg',
    label: 'UTC+06:00 - Ekaterinburg'
  },
  {
    value: 'yangon-rangoon',
    label: 'UTC+06:30 - Yangon Rangoon'
  },
  {
    value: 'bangkok-hanoi-jakarta',
    label: 'UTC+07:00 - Bangkok, Hanoi, Jakarta'
  },
  {
    value: 'novosibirsk',
    label: 'UTC+07:00 - Novosibirsk'
  },
  {
    value: 'beijing-chongqing-hong-kong-urumqi',
    label: 'UTC+08:00 - Beijing, Chongqing, Hong Kong, Urumqi'
  },
  {
    value: 'krasnoyarsk',
    label: 'UTC+08:00 - Krasnoyarsk'
  },
  {
    value: 'perth',
    label: 'UTC+08:00 - Perth'
  },
  {
    value: 'taipei',
    label: 'UTC+08:00 - Taipei'
  },
  {
    value: 'irkutsk-ulaan-bataar',
    label: 'UTC+09:00 - Irkutsk, Ulaan Bataar'
  },
  {
    value: 'osaka-sapporo-tokyo',
    label: 'UTC+09:00 - Osaka, Sapporo, Tokyo'
  },
  {
    value: 'seoul',
    label: 'UTC+09:00 - Seoul'
  },
  {
    value: 'adelaide',
    label: 'UTC+09:30 - Adelaide'
  },
  {
    value: 'darwin',
    label: 'UTC+09:30 - Darwin'
  },
  {
    value: 'brisbane',
    label: 'UTC+10:00 - Brisbane'
  },
  {
    value: 'canberra-melbourne-sydney',
    label: 'UTC+10:00 - Canberra, Melbourne, Sydney'
  },
  {
    value: 'hobart',
    label: 'UTC+10:00 - Hobart'
  },
  {
    value: 'yakutsk',
    label: 'UTC+10:00 - Yakutsk'
  },
  {
    value: 'solomon-is-new-caledonia',
    label: 'UTC+11:00 - Solomon Is., New Caledonia'
  },
  {
    value: 'vladivostok',
    label: 'UTC+11:00 - Vladivostok'
  },
  {
    value: 'auckland-wellington',
    label: 'UTC+12:00 - Auckland, Wellington'
  },
  {
    value: 'fiji-kamchatka-marshall-is',
    label: 'UTC+12:00 - Fiji, Kamchatka, Marshall Is.'
  },
  {
    value: 'magadan',
    label: 'UTC+12:00 - Magadan'
  },
  {
    value: 'nukualofa',
    label: 'UTC+13:00 - Nuku\'alofa'
  }
]

export const APP_PLANS = [
  {
    id: 'PACK-GESTION',
    new: true,
    name: 'Pack starter Gestion SEKUR',
    features: [
      'Toutes les fonctionnalités',
      '1 compte admin (le compte propriétaire)',
      '50 fiches agents'
    ],
    price: 49.99,
    v4: true
  },
  {
    id: 'PACK-TERRAIN',
    new: true,
    name: 'Pack starter Terrain SEKUR',
    features: [
      'Toutes les fonctionnalités',
      '1 compte admin (le compte propriétaire)',
      '5 fiches agents',
      '5 comptes utilisateurs agent/admin'
    ],
    price: 69.99,
    v4: true
  },
  {
    id: 'PLAN-05',
    name: '- de 5 agents',
    range: {
      min: 1,
      max: 5
    },
    price: 49.99,
    agents: 5,
    support: 0
  },
  {
    id: 'PLAN-10',
    name: '- de 10 agents',
    range: {
      min: 6,
      max: 10
    },
    price: 69.99,
    agents: 10,
    support: 0
  },
  {
    id: 'PLAN-15',
    name: '- de 15 agents',
    range: {
      min: 11,
      max: 15
    },
    price: 89.99,
    agents: 15,
    support: 0
  },
  {
    id: 'PLAN-20',
    name: '- de 20 agents',
    range: {
      min: 16,
      max: 20
    },
    price: 99.99,
    agents: 20,
    support: 0
  },
  {
    id: 'PLAN-30',
    name: '- de 30 agents',
    range: {
      min: 21,
      max: 30
    },
    price: 149.99,
    agents: 30,
    support: 0
  },
  {
    id: 'PLAN-50',
    name: '- de 50 agents',
    range: {
      min: 31,
      max: 50
    },
    price: 199.99,
    agents: 50,
    support: 30
  },
  {
    id: 'PLAN-100',
    name: '- de 100 agents',
    range: {
      min: 51,
      max: 100
    },
    price: 299.99,
    agents: 100,
    support: 60
  },
  {
    id: 'PLAN-200',
    name: '- de 200 agents',
    range: {
      min: 101,
      max: 200
    },
    price: 399.99,
    agents: 200,
    support: 60
  },
  {
    id: 'PLAN-300',
    name: '- de 300 agents',
    range: {
      min: 201,
      max: 300
    },
    price: 499.99,
    agents: 300,
    support: 60
  },
  {
    id: 'PLAN-500',
    name: '- de 500 agents',
    range: {
      min: 301,
      max: 500
    },
    price: 599.99,
    agents: 500,
    support: 60
  },
  {
    id: 'PLAN-1000',
    name: '1000 et plus',
    range: {
      min: 501,
      max: 1000
    },
    price: 699.99,
    agents: 1000,
    support: 60
  }
]

export const APP_PLAN_ACCOUNTS = [
  {
    id: 'PACK-ACCOUNT-5',
    value: 5,
    name: 'Pack 5 Agents',
    price: 49.99
  },
  {
    id: 'PACK-ACCOUNT-10',
    value: 10,
    name: 'Pack 10 Agents',
    price: 69.99
  },
  {
    id: 'PACK-ACCOUNT-15',
    value: 15,
    name: 'Pack 15 Agents',
    price: 89.99
  },
  {
    id: 'PACK-ACCOUNT-20',
    value: 20,
    name: 'Pack 20 Agents',
    price: 99.99
  },
  {
    id: 'PACK-ACCOUNT-30',
    value: 30,
    name: 'Pack 30 Agents',
    price: 149.99
  },
  {
    id: 'PACK-ACCOUNT-50',
    value: 50,
    name: 'Pack 50 Agents',
    price: 199.99
  },
  {
    id: 'PACK-ACCOUNT-100',
    value: 100,
    name: 'Pack 100 Agents',
    price: 299.99
  },
  {
    id: 'PACK-ACCOUNT-200',
    value: 200,
    name: 'Pack 200 Agents',
    price: 399.99
  },
  {
    id: 'PACK-ACCOUNT-300',
    value: 300,
    name: 'Pack 300 Agents',
    price: 499.99
  },
  {
    id: 'PACK-ACCOUNT-500',
    value: 500,
    name: 'Pack 500 Agents',
    price: 599.99
  },
  {
    id: 'PACK-ACCOUNT-1000',
    value: 1000,
    name: 'Pack 1000 Agents',
    price: 999.99
  }
]

export const APP_PLAN_FILES = [
  {
    id: 'PACK-FILE-20',
    value: 20,
    name: 'Pack 20 fiches Agents',
    price: 19.99
  },
  {
    id: 'PACK-FILE-50',
    value: 50,
    name: 'Pack 50 fiches Agents',
    price: 39.99
  },
  {
    id: 'PACK-FILE-100',
    value: 100,
    name: 'Pack 100 fiches Agents',
    price: 59.99
  },
  {
    id: 'PACK-FILE-200',
    value: 200,
    name: 'Pack 200 fiches Agents',
    price: 79.99
  },
  {
    id: 'PACK-FILE-300',
    value: 300,
    name: 'Pack 300 fiches Agents',
    price: 99.99
  }
]

const APP_TUTORIAL_URL = 'https://www.youtube.com/embed/'

/**
 * Liste des tutoriels vidéos
 */
export const APP_TUTORIALS = [

  {
    label: 'Général',
    videos: [
      {
        label: 'Présentation générale',
        src: APP_TUTORIAL_URL + 'PNCMNsiJeoI'
      }
    ]
  },
  {
    label: 'Agents',
    roles: [ROLE_AGENT, ROLE_MANAGER],
    videos: [
      {
        label: 'Heures travaillées planning',
        src: APP_TUTORIAL_URL + 'dQzCVZUXvpQ'
      },
      {
        label: 'Service non-planifié (intervention)',
        src: APP_TUTORIAL_URL + 'B3qePUw5_N4'
      },
      {
        label: 'Service planifié',
        src: APP_TUTORIAL_URL + '-9p7_CzHbOA'
      },
      {
        label: 'Tournée (non-planifiée)',
        src: APP_TUTORIAL_URL + 'dqgUgfYcAws'
      }
    ]
  },
  {
    label: 'Gestion',
    videos: [
      {
        label: 'Tableau de Bord',
        src: APP_TUTORIAL_URL + '9mQwtoyx1cE',
        roles: [ROLE_MANAGER]
      },
      {
        label: 'Création Service, Récurrence et Tournée',
        src: APP_TUTORIAL_URL + 'zQkC5QEa3Cw',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_MISSION]
      },
      {
        label: 'Planning',
        src: APP_TUTORIAL_URL + 'D06z7_5A7hI',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_READ_SITES_PLANNING]
      },
      {
        label: 'Gestion Création Indisponibilités',
        src: APP_TUTORIAL_URL + 'B-7v-3tvg6w',
        roles: [ROLE_MANAGER]
      }
    ]
  },
  {
    label: 'Terrain',
    videos: [
      {
        label: 'Gestion Main Courante',
        src: APP_TUTORIAL_URL + 'ybVxRE_NGGQ',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_MISSION_EVENT]
      },
      {
        label: 'Gestion Création Bon d\'intervention',
        src: APP_TUTORIAL_URL + 'nKQvYfBmak0',
        roles: [ROLE_MANAGER]
      },
      {
        label: 'Création Gestion des Rondes',
        src: APP_TUTORIAL_URL + 'K52dty2LwrE',
        isGranted: [ACCOUNT_RIGHT_CREATE_ROUND]
      },
      {
        label: 'Création Gestion Point de contrôle',
        src: APP_TUTORIAL_URL + 'NK2bHFcAAOo',
        isGranted: [ACCOUNT_RIGHT_CREATE_CHECKPOINT]
      }
    ]
  },
  {
    label: 'Agence',
    videos: [
      {
        label: 'Création gestion Client',
        src: APP_TUTORIAL_URL + 'Q--2f6fj24A',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_CUSTOMER]
      },
      {
        label: 'Gestion Création Site',
        src: APP_TUTORIAL_URL + 'qFx_reZFc84',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_SITE]
      },
      {
        label: 'Gestion Création Agent',
        src: APP_TUTORIAL_URL + 'E9As-V3R_cM',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_AGENT]
      },
      {
        label: 'Création Gestion Administrateur',
        src: APP_TUTORIAL_URL + 'FgPIhzx5EVs',
        roles: [ROLE_MANAGER]
      }
    ]
  },
  {
    label: 'Facturation',
    videos: [
      {
        label: 'Création Gestion Devis et Factures',
        src: APP_TUTORIAL_URL + 'fB9RZZvCqSs',
        roles: [ROLE_MANAGER, ROLE_AGENT],
        isGranted: [ACCOUNT_RIGHT_CREATE_INVOICE]
      }
    ]
  },
  {
    label: 'Paramètres',
    videos: [
      {
        label: 'Paramètres Agence',
        src: APP_TUTORIAL_URL + 'UYtOvLqNoaM',
        roles: [ROLE_MANAGER],
        isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS]
      },
      {
        label: 'Paramètres Terrain',
        src: APP_TUTORIAL_URL + 'J5NfViV8pS4',
        roles: [ROLE_MANAGER],
        isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS]
      },
      {
        label: 'Paramètres Devis Facture',
        src: APP_TUTORIAL_URL + '0cgfIOW0324',
        roles: [ROLE_MANAGER],
        isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS]
      },
      {
        label: 'Paramètres Export et Email',
        src: APP_TUTORIAL_URL + '4D9AUpLCx6Q',
        roles: [ROLE_MANAGER],
        isGranted: [ACCOUNT_RIGHT_EDIT_AGENCY_PARAMETERS]
      }
    ]
  }
]

export const MODAL_EVENT_RELOAD_SERVICES = 'lwf:reloadServices'
export const MODAL_EVENT_UPDATE_SERVICES = 'lwf:updateServices'
export const MODAL_EVENT_UPDATE_AGENTS = 'lwf:updateAgents'
export const MODAL_EVENT_UPDATE_ESTIMATES = 'lwf:updateEstimates'
export const MODAL_EVENT_UPDATE_INVOICES = 'lwf:updateInvoices'
export const MODAL_EVENT_UPDATE_MANAGER = 'lwf:updateManager'
export const MODAL_EVENT_UPDATE_UNAVAILABILITIES = 'lwf:updateUnavailabilities'
export const MODAL_EVENT_UPDATE_SERVICE_EVENT = 'lwf:updateServiceEvent'
export const MODAL_EVENT_UPDATE_INTERVENTION_REPORTS = 'lwf:updateInterventionReport'
export const MODAL_EVENT_UPDATE_AGENT_REQUEST = 'lwf:updateAgentRequest'
export const MODAL_EVENT_UPDATE_SITE_INSTRUCTIONS = 'lwf:updateSiteInstructions'
export const EVENT_UPDATE_AGENT_LOCATION = 'lwf:updateAgentLocation'
export const MODAL_EVENT_UPDATE_CHANGELOG = 'lwf:updateChangelog'
export const MODAL_EVENT_UPDATE_FEEDBACK = 'lwf:updateFeedback'
export const MODAL_EVENT_UPDATE_INVOICE_RECURRENCE = 'lwf:updateInvoiceRecurrence'
export const MODAL_EVENT_UPDATE_CONTRACT_TEMPLATE = 'lwf:updateContractTemplate'
export const MODAL_EVENT_UPDATE_AGENT_CONTRACT_TEMPLATE = 'lwf:updateAgentContractTemplate'
export const MODAL_EVENT_UPDATE_CUSTOMER_CONTRACT_TEMPLATE = 'lwf:updateCustomerContractTemplate'
export const MODAL_EVENT_UPDATE_CONTRACT = 'lwf:updateContract'

export const FORM_LOGIN_LOGIN = 'login'
export const FORM_LOGIN_REGISTER = 'register'
export const FORM_LOGIN_FORGOT = 'forgot'
export const FORM_LOGIN_RESET = 'reset'
